import React, { useEffect } from 'react';
import { oneOf, func, object } from 'prop-types';
import { Text, Heading, Box } from '@chaser/components';
import { Redirect } from 'react-router';
import LoadingMessage from '../../../../components/LoadingMessage/index';
import ErrorIcon from '../../../../assets/alert-icons/error.svg';
import CheckIcon from '../../../../assets/alert-icons/success.svg';
import usePush from '../../../../hooks/usePush';
import VERIFICATION_TYPES from '../../types';
import RouterButton from '../../../../components/RouterButton';
import Logo from '../../../../components/Logo';
import style from './VerifyNotif.module.scss';

const expiredLink = () => (
  <>
    <img src={ErrorIcon} alt="" />
    <Heading as="h1">Link expired</Heading>
    <Text color="Mid Neutral 1" className={style.subText}>
      The link you used has expired and can’t{'\n'}
      be used to validate this email address.
    </Text>
  </>
);

const verifiedLink = () => (
  <>
    <img src={CheckIcon} alt="" />
    <Heading as="h1">Email validated</Heading>
    <Text color="Mid Neutral 1" className={style.subText}>
      Thanks for confirming your email address.
    </Text>
  </>
);

const VerifyNotif = ({ type, method, params }) => {
  const { execute, response: data, error } = usePush(method);
  useEffect(() => {
    execute(params);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (error)
    return (
      <Box p="medium">
        <Text fontSize="medium" textAlign="center" color="white">
          {error}
        </Text>
      </Box>
    );

  if (!data && !error)
    return (
      <div className={style.verifyContainer}>
        <div className={style.header}>
          <Logo />
        </div>
        <div className={style.body}>
          <LoadingMessage />
        </div>
      </div>
    );

  return (
    <div
      className={style.verifyContainer}
      data-testid="verify-notif"
      data-trackingid="verify-notif"
    >
      <div className={style.header}>
        <Logo />
      </div>
      <div className={style.body}>
        {
          {
            SENDER: (
              <>
                {data.verifySender && verifiedLink()} {!data.verifySender && expiredLink()}
              </>
            ),
            EMAIL:
              data.shouldSetPassword && params.passwordToken ? (
                <Redirect
                  to={`/new-password?email=${encodeURIComponent(params.email)}&token=${
                    params.passwordToken
                  }`}
                />
              ) : (
                <>
                  <img src={CheckIcon} alt="" />
                  <Heading as="h1">Email verified</Heading>
                  <Text color="Mid Neutral 1" className={style.subText}>
                    Your email address has been confirmed. You can now log in to Chaser.
                  </Text>
                  <RouterButton to="/login" style={{ width: '100%' }}>
                    Go to Chaser
                  </RouterButton>
                </>
              ),
          }[type]
        }
      </div>
    </div>
  );
};

export default VerifyNotif;

VerifyNotif.propTypes = {
  type: oneOf(Object.values(VERIFICATION_TYPES)).isRequired,
  method: func.isRequired,
  params: object.isRequired,
};
